import React from 'react';
import './Contact.css'; // Optional styling

const Contact = () => {
  return (
    <div className="contact-container">
      <h2>We would love to hear from you</h2>
      <p>Get in touch for more information about our offerings.</p>

      <form
        className="contact-form"
        action="https://formspree.io/f/xrbllyyd"  // ← Replace this with your real endpoint
        method="POST"
      >
        <label>
          Name:
          <input type="text" name="name" placeholder="Your name" required />
        </label>
        <br />
        <label>
          Email:
          <input type="email" name="email" placeholder="Your email" required />
        </label>
        <br />
        <label>
          Message:
          <textarea name="message" placeholder="Your message" rows="5" required />
        </label>
        <br />
        <button type="submit">Send</button>
      </form>
    </div>
  );
};

export default Contact;

